export default __webpack_public_path__ + "static/Masii_logo-b2db70a680142c4c638a4d40a094f6cd.png";